export class AppState {
  isOnline: boolean;
  isInternetConnected: boolean;
  isElectron: boolean;
  maxDaysWithoutSync = 3;
  lastSynchronizationDate: Date;
  synchronizationStatus: number;
  localServerFailure: boolean;
}
